"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyles = void 0;
var _styledComponents = require("styled-components");
var InputStyles = exports.InputStyles = {
  Base: (0, _styledComponents.css)(["box-sizing:border-box;padding:16px 8px;height:48px;transition:background-color 300ms,border-color 300ms;border:none;background-color:transparent;font-family:inherit;font-size:14px;font-style:normal;font-weight:500;line-height:16px;"]),
  Normal: (0, _styledComponents.css)(["background-color:var(--white);border:1px solid var(--grey3);border-radius:var(--border-radius);"]),
  Error: (0, _styledComponents.css)(["border:1px solid var(--secondary);"]),
  Disabled: (0, _styledComponents.css)(["background-color:transparent;"]),
  Placeholder: (0, _styledComponents.css)(["color:var(--grey2);"]),
  Focus: (0, _styledComponents.css)(["outline:none;"]),
  Small: (0, _styledComponents.css)(["height:40px;"])
};